import { useState } from "react";
import { Button, Modal } from "antd";

import paperShredder from "../../assets/images/webToLead/paper-shredder.svg";

const RemoveAccount = ({ onRemove }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button className="stop-sync" onClick={() => showModal()}>
        Remove Account
      </Button>
      <Modal
        title={
          <div className="tw-bg-secondary-color tw-text-text-primary tw-text-lg tw-font-semibold tw-py-4 tw-px-6 tw-rounded-t-2xl">
            Remove Account
          </div>
        }
        className="delete-popup"
        open={isModalOpen}
        centered
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
      >
        <div
          style={{ padding: "0 24px 20px 24px" }}
          className="web-to-lead mt10"
        >
          <div
            className="d-flex align-items-center"
            style={{ gap: 50, margin: "0 24px 20px 24px" }}
          >
            <img src={paperShredder} alt="" />
            <div className="text-color-434040 heading16px mt10">
              <div>Are you sure you want to remove account?</div>
              <div className="mt10">
                Removing your email account will halt all future email tracking
                and synchronization.
              </div>
            </div>
          </div>
        </div>
        <div className="tw-flex tw-bg-secondary-color tw-rounded-b-2xl tw-py-4 tw-px-6 tw-items-center tw-justify-end tw-gap-4">
          <Button
            className="tw-border-sub-text hover:!tw-border-sub-text tw-text-sm tw-text-sub-text hover:!tw-text-sub-text"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            className="stop-sync"
            onClick={() => {
              onRemove();
              handleCancel();
            }}
          >
            Remove
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default RemoveAccount;
